var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"side-menu-trigger",class:[{ 'not-collapse': !_vm.isCollapse }],on:{"click":_vm.toggleTrigger}},[_c('svg-icon',{attrs:{"name":"fold","width":"20","height":"20"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }